import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IFileUpload } from '../../interfaces';
import { INPUT_FILE_CONFIG, IRoblexInputConfig } from './input-file.config';

@Injectable({ providedIn: 'root' })
export class InputFileService {
    constructor(
        @Inject(INPUT_FILE_CONFIG) private configInputValue: IRoblexInputConfig,
        private http: HttpClient
    ) {
        //
    }

    upload(file: any): Observable<IFileUpload> {
        
        const formData = new FormData();

        formData.append('file', file);

        return this.http.post<IFileUpload>(this.configInputValue.api, formData);
    }
}
